/** 
 * Informações das colunas para lista
 * @type {Array<{
 *   label: string,
 *   name: string,
 *   width: string | number,
 *   colSpan: string | number,
 *   className: string,
 *   style: string
 * }>} 
*/
export const columns = [
    {
        label: 'Cod.',
        name: 'cod',
        width: '10%',
        className: '',
    },
    {
        label: 'Horas por Dia',
        name: 'hora_dia',
        width: '25%',
        // className: 'd-none d-md-block w-auto',
    },
    {
        label: 'Horas Totais no Mês',
        name: 'hora_total',
        width: '25%',
    },
    {
        label: 'Regime',
        name: 'id_regime',
        width: '40%',
    },
];


const CargaHorariaListInfo = { columns };

export default CargaHorariaListInfo;